import { render, staticRenderFns } from "./UserDropdownComponent.vue?vue&type=template&id=5e319613&scoped=true&"
import script from "./UserDropdownComponent.vue?vue&type=script&lang=js&"
export * from "./UserDropdownComponent.vue?vue&type=script&lang=js&"
import style0 from "./UserDropdownComponent.vue?vue&type=style&index=0&id=5e319613&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e319613",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VChip,VIcon,VList,VListItem,VListItemTitle,VMenu})
